export const TRACKING_CONFIG = {
  ga4: {
    enabled: true,
    measurementId: 'G-110634VZIL'
  },
  googleAds: {
    enabled: false,
    measurementId: 'AW-17945822755',
    conversionLabels: {
      whatsappClick: '',
      phoneClick: '',
      pageView: ''
    }
  },
  metaPixel: {
    enabled: false,
    pixelId: '',
    events: {
      whatsappClick: 'Contact',
      phoneClick: 'Contact',
      viewContent: 'ViewContent',
      lead: 'Lead'
    }
  },
  googleTagManager: {
    enabled: false,
    containerId: 'GTM-PB6X86PF'
  }
};

export const isTrackingConfigured = () => {
  const googleConfigured = Boolean(
    (TRACKING_CONFIG.ga4.enabled && TRACKING_CONFIG.ga4.measurementId) ||
    (TRACKING_CONFIG.googleAds.enabled && TRACKING_CONFIG.googleAds.measurementId) ||
    (TRACKING_CONFIG.googleTagManager.enabled && TRACKING_CONFIG.googleTagManager.containerId)
  );

  const metaConfigured = Boolean(
    TRACKING_CONFIG.metaPixel.enabled && TRACKING_CONFIG.metaPixel.pixelId
  );

  return {
    google: googleConfigured,
    meta: metaConfigured,
    any: googleConfigured || metaConfigured
  };
};
